<template>
	<div>
		<div class="box">
			<div class="row">
				<h2 class="match-header">Add Filter Word</h2>
			</div>
            <div class="configuration-reference">
				<!-- Filter Words -->
				<div class="card-row row">
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Filter Word</label>
							<md-input v-model.trim="filterWord" name="word" v-validate="'required|max:25'" placeholder="Add Filter Word" @input="filterWord = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('word')">{{errors.first('word')}}</p>
					</div>
				</div>

				<!-- Common save btn -->
				<div class="row">
					<div class="submitBtn">
						<md-button type="button" @click="saveFilterWord()" class="md-raised md-round md-accent">Save</md-button>
						<md-button type="button" @click="cancel()" class="md-raised md-round md-accent">Cancel</md-button>
					</div>
				</div>
            </div>
		</div>
	</div>
</template>
<script>
import API from "../services/API";
import { sanitizeInput } from "../utils/sanitizer";
export default {
    data() {
        return {
            fullPage: true,
            api: new API(),
            filterWord: ''
        }
    },
    watch: {
      $route: "loadData"
    },
    created() {
		const dict = {
			custom: {
				filterWord: {
					required: 'Please enter filter word',
					max: 'Filter word may not be greater than 25 characters'
				}
			}
		};
		this.$validator.localize('en', dict);
    },
    methods: {
        saveFilterWord: async function() {
			this.$validator.validateAll().then(async (result) => {
				if (result) {
					const sanitizedWord = sanitizeInput(this.filterWord);
					await this.api.post(`configuration/add-filter-word`, {word: sanitizedWord}).then(responseData => {
						if (responseData.data && responseData.data.status) {
							this.$router.push('/configuration/reference-filter-words');
						} else {
							this.$toast.error(responseData.data.msg);
						}
					});
				}
			})
		},
		cancel: async function() {
			this.$router.push('/configuration/reference-filter-words');
		},
		sanitizeInput(event) {
			return sanitizeInput(event);
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfigurationAdd.vue